export const PIKKO_JACKPOT_ENDPOINTS = {
  WEBAPP_OFFER_STATUS: '/jackpot/webapp/offer-status',
  REACTIVATE: '/jackpot/reactivate',
};
